if (!customElements.get('casebang-halloween-codes')) {
  customElements.define('casebang-halloween-codes', class extends HTMLElement {
    connectedCallback() {
      if (this.copyController) return;
      this.copyController = new AbortController();
      this.addEventListener('click', this.onCopy, { signal: this.copyController.signal });
    }
    disconnectedCallback() {
      this.copyController?.abort();
      this.copyController = null;
    }
    async writeCode(value) {
      if (navigator.clipboard && window.isSecureContext) {
        try { await navigator.clipboard.writeText(value); return; } catch (error) {}
      }
      const input = document.createElement('textarea');
      input.value = value;
      input.readOnly = true;
      input.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
      this.appendChild(input);
      input.select();
      input.setSelectionRange(0, value.length);
      let copied = false;
      try { copied = document.execCommand('copy'); } finally { input.remove(); }
      if (!copied) throw new Error('Clipboard unavailable');
    }
    onCopy = async (event) => {
      const button = event.target.closest('.cbh-copy-code__button');
      if (!button || !this.contains(button) || button.disabled) return;
      const code = button.dataset.copyCode;
      if (!code) return;
      const status = this.querySelector('[data-copy-status]');
      button.disabled = true;
      try {
        await this.writeCode(code);
        if (!this.isConnected) return;
        this.querySelectorAll('.cbh-copy-code__button').forEach((item) => {
          item.classList.remove('is-copied');
          item.querySelector('[data-copy-action]').textContent = item.dataset.copyLabel;
          item.setAttribute('aria-label', `${item.dataset.copyLabel} ${item.dataset.copyCode}`);
        });
        button.classList.add('is-copied');
        button.querySelector('[data-copy-action]').textContent = button.dataset.copiedLabel;
        button.setAttribute('aria-label', `${button.dataset.copiedLabel} ${code}`);
        if (status) status.textContent = `${button.dataset.copiedLabel} ${code}`;
      } catch (error) {
        if (status) status.textContent = this.dataset.errorLabel;
      } finally {
        button.disabled = false;
        button.focus({ preventScroll: true });
      }
    };
  });
}
